import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EndpointFactory {
  private _baseUrl = environment.baseUrl;
  public readonly GetBgModelById: string =
    this._baseUrl + '/bgmodel/GetBgModel';

  public readonly AddCustomItem: string =
    this._baseUrl + '/BgModelAddon/AddonBomItem';

  public readonly DeleteCustomItem: string =
    this._baseUrl + '/BgModelAddon/DeleteBomItem';
  // public readonly SearchModels: string =
  //   this._baseUrl + '/bgmodel/searchbycompany';
  // public readonly SearchBobModels: string =
  //   this._baseUrl + '/bgmodel/getagreagatedmodelsbycompany';

  public readonly SendEmailToSupport: string =
    this._baseUrl + '/Communication/SendEmailToSupport';

  public readonly SendClientSupportMessage: string =
    this._baseUrl + '/Communication/SendClientSupportMessage';

  public readonly CreateDemoUser: string =
    this._baseUrl + '/Authorization/CreateDemoUser';

  public readonly LoginDemoUser: string =
    this._baseUrl + '/Authorization/LoginDemo';

    public readonly CompareBomModels: string =
    this._baseUrl + '/bgmodel/CompareBomModels';


    public readonly PatchBomModelStructure: string =
    this._baseUrl + '/BgModel/PatchBomModelStructure';

    public readonly AskAiAssistant: string =
    this._baseUrl + '/Communication/AskAiAssistant';

    public readonly ChangePassword: string =
    this._baseUrl + '/Password/ChangePassword';

    public readonly CreateUser: string =
    this._baseUrl + '/Users/CreateUser';

    public readonly GetUsers: string =
    this._baseUrl + '/Users/GetUsers';

    public readonly UpdateUserPermissions: string =
    this._baseUrl + '/Users/UpdateUserPermissions';

    public readonly DeleteUser: string =
    this._baseUrl + '/Users/DeleteUser';

    public readonly GetClient: string =
    this._baseUrl + '/Client/GetClient';

    public readonly GetAllClients: string =
    this._baseUrl + '/Client/GetAllClientsWithoutProjectStructure';

    public readonly UpdateClient: string =
    this._baseUrl + '/Client/UpdateClient';

    public readonly DeleteClient: string =
    this._baseUrl + '/Client/DeleteClient';

    public readonly GetBgModelsByClientId: string =
    this._baseUrl + '/bgmodel/GetBgModelsByClientId';

    // Push Notification endpoints
    public readonly PushNotificationSubscribe: string =
    this._baseUrl + '/communication/notifications/subscribe';

    public readonly PushNotificationUnsubscribe: string =
    this._baseUrl + '/communication/notifications/unsubscribe';

    public readonly PushNotificationUpdate: string =
    this._baseUrl + '/communication/notifications/update';


    //communication

    public readonly CreateEmptyTopic: string =  //create new topic
    this._baseUrl + '/communication/project/:id/topic';

    public readonly GetMemberProjectCommunications: string = //get all projects for user
    this._baseUrl + '/communication/projects/user';

    public readonly GetUnresolvedTopicsByProjectForUser: string = //get unresolved topics (all for admin) - use for sidebar
    this._baseUrl + '/communication/project/:projectId/unresolved-topics/user';

    public readonly UpdateTopicStatus: string = //update topic status
    this._baseUrl + '/communication/project/:projectId/topic/:id/status';

    public readonly UpdateTopicMessage: string = //update topic message
    this._baseUrl + '/communication/project/:projectId/topic/:id/message/:messageid';

    public readonly UpdateProjectStatus: string = //update project status
    this._baseUrl + '/communication/project/:id/status';

    public readonly UpdateTopicTitle: string = //update topic title
    this._baseUrl + '/communication/project/:projectId/topic/:id';

    public readonly AddTopicMessage: string = //add topic message
    this._baseUrl + '/communication/project/:projectId/topic/:id/message';

    public readonly GetUsersByClientId: string = //get users by client id (customers)
    this._baseUrl + '/Users/GetUsersByClientId';

    public readonly GetUnreadMessages: string = //get unread messages (for badge)
    this._baseUrl + '/communication/topic/unresolved-topics/user/unread-messages';

    public readonly MarkTopicMessagesAsVisited: string = //mark topic messages as visited
    this._baseUrl + '/communication/project/:projectId/topic/:id/user/visited';

    public readonly DeleteFileByUrl: string = //delete file by url
    this._baseUrl + '/files/file';

    public readonly UploadFile: string = //upload file
    this._baseUrl + '/files/file';

    public readonly UploadImage: string = //upload image
    this._baseUrl + '/files/image';

    //commercial offer
    public readonly GetOffersPreviews: string =
    this._baseUrl + '/commercialoffer/clients/preview';  //to get all offers (use for sidebar also)

    public readonly GetOfferById: string =
    this._baseUrl + '/commercialoffer/bom/:modelId/:offerId';  //to get offer by id (use when clicking on offer in sidebar)

    public readonly CreateEmptyCommercialOffer: string =
    this._baseUrl + '/commercialoffer/:modeld/create-empty';  //to create empty offer (use when clicking on "New" button in sidebar)

    public readonly GetMaterials: string =
    this._baseUrl + '/commercialoffer/bom/materials/:modelId';  // we will have button 'add the material'

    public readonly AddNewVersion: string =
    this._baseUrl + '/commercialoffer/:modeld/:offerId/v/add-version'; //use for patch the offer (add new or new version)

    public readonly EditVersion: string =
    this._baseUrl + '/commercialoffer/:modeld/:offerId/v/:version/edit'; //use for edit selected version

    public readonly GetNewCommercialOffer: string =
    this._baseUrl + '/commercialoffer/bom/:modelId';

    public readonly CreateCommercialOffer: string =
    this._baseUrl + '/commercialoffer/bom/:modelId';

    public readonly InviteOfferees: string =
    this._baseUrl + '/commercialoffer/:modelId/:offerId/v/:version/invite';  //use for invite offerees

    public readonly DeleteOffer: string =
    this._baseUrl + '/commercialoffer/bom/:modelId/:offerId';  // deprecated

    public readonly AddCommentToOffer: string =
    this._baseUrl + '/commercialoffer/:modelId/:offerId/v/:version/comment';  //use for add comment to offer

    public readonly GetOffereeOffer: string =
    this._baseUrl + '/commercialoffer/offeree/:offereeId';

    public readonly UpdateOffereeStatus: string =
    this._baseUrl + '/commercialoffer/:modelId/:offerId/:offereeId/v/:version?status=:status';  //use for update offeree status

    public readonly UpdateOffer: string =
    this._baseUrl + '/commercialoffer/:modelId/:offerId';

    public readonly GetPricesFromDocument : string =
    this._baseUrl + '/commercialoffer/ai-assistant/price/auto-complete';

    public readonly ExtractItemsFromDocument : string =
    this._baseUrl + '/commercialoffer/ai-assistant/items/auto-complete';

    public readonly ProcessOfferItems: string =
    this._baseUrl + '/commercialoffer/ai-assistant/items/process';

    // RFP (customer)
    public readonly GetRfpBomForRfp: string = //aggregate BOM by model for RFP item selection
    this._baseUrl + '/rfp/bom/:modelId';

    public readonly CreateRfp: string = //create new RFP for a model
    this._baseUrl + '/rfp/:modelId/create';

    public readonly GetRfpById: string = //get full RFP details by id
    this._baseUrl + '/rfp/:rfpId';

    public readonly GetAllRfps: string = //list all RFPs for client
    this._baseUrl + '/rfp';

    public readonly GetRfpPreviews: string = //lightweight RFP list for dashboards
    this._baseUrl + '/rfp/preview';

    public readonly GetRfpPreviewsByModelId: string = //RFP previews for a specific BG model
    this._baseUrl + '/rfp/preview/model/:modelId';

    public readonly UpdateRfp: string = //update RFP data and items
    this._baseUrl + '/rfp/:rfpId';

    public readonly PublishRfp: string = //publish draft RFP for submissions
    this._baseUrl + '/rfp/:rfpId/publish';

    public readonly CloseRfp: string = //close RFP to stop submissions
    this._baseUrl + '/rfp/:rfpId/close';

    public readonly DeleteRfp: string = //permanently delete RFP
    this._baseUrl + '/rfp/:rfpId';

    public readonly MarkRfpAsDeleted: string = //soft-delete RFP (preserves data)
    this._baseUrl + '/rfp/mark-deleted/:rfpId';

    public readonly InviteContractors: string = //invite contractors via email links
    this._baseUrl + '/rfp/:rfpId/invite';

    public readonly SelectContractor: string = //select winning contractor
    this._baseUrl + '/rfp/:rfpId/select-contractor/:contractorId';

    // RFP (contractor - public)
    public readonly GetRfpForContractor: string = //contractor view via invite link
    this._baseUrl + '/rfp/contractor/:contractorId';

    public readonly SubmitProposal: string = //submit contractor proposal
    this._baseUrl + '/rfp/contractor/:contractorId/submit';

    public readonly UpdateProposal: string = //update contractor proposal
    this._baseUrl + '/rfp/contractor/:contractorId/update';

    public readonly DeclineRfp: string = //decline invitation
    this._baseUrl + '/rfp/contractor/:contractorId/decline';

    public readonly UpdateContractorStatusViewed: string = //mark contractor status as viewed
    this._baseUrl + '/rfp/contractor/:contractorId/status/viewed';

    // RFP (admin/internal)
    public readonly UpdateContractorStatus: string = //manual status override
    this._baseUrl + '/rfp/:rfpId/contractor/:contractorId/status';

    // Google Drive (BgGoogleController)
    public readonly ConvertGoogleDriveFolderUrlToId: string =
    this._baseUrl + '/BgGoogle/googledrive/folder/by-url/id';

    public readonly GetGoogleDriveFilesByFolderId: string =
    this._baseUrl + '/BgGoogle/googledrive/folder/:folderId/files';

    public readonly DownloadGoogleDriveFileById: string =
    this._baseUrl + '/BgGoogle/googledrive/file/:fileId/download';

    // Client Contractors (authenticated client)
    public readonly AddClientContractor: string =
    this._baseUrl + '/client-contractors/add';

    public readonly GetAllClientContractors: string =
    this._baseUrl + '/client-contractors/all';

    public readonly DeleteClientContractor: string =
    this._baseUrl + '/client-contractors/:contractorId';
  }

